import React, { FC } from 'react';
import { IReviewNew } from '../../../shared/interfaces/IReviewNew';
import { Avatar, Box, Typography, useTheme } from '@mui/material';
import ReviewWrapper from '../ReviewWrapper';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import ReviewFooter from '../ReviewFooter';
import { CommunityManagement } from '../../../shared/interfaces/ICommunityManagement';
import ReviewText from '../ReviewText';

interface Props extends IReviewNew {
  communityManagement?: CommunityManagement;
  commentingModule: boolean;
  hideHeader: boolean;
  hideFooter: boolean;
}

const TripAdvisorReview: FC<Props> = ({
  id,
  review,
  platform,
  reviewComment,
  communityManagement,
  commentingModule,
  note,
  deletion,
  deleted,
  timestamp,
  hideHeader,
  hideFooter,
  history,
}) => {
  const theme = useTheme();

  const { name, ratingValue, profilePicture, reviewText, reviewTitle, companyComment, url } =
    review;

  return (
    <ReviewWrapper>
      <ReviewHeader
        hide={hideHeader}
        rating={ratingValue}
        platform={platform}
        timestamp={timestamp}
        reviewLink={url}
        id={id}
        note={note}
        deletion={deletion}
        commentingModule={commentingModule}
        deleted={deleted}
      />
      <ReviewContent>
        {name && profilePicture && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: theme.palette.text.secondary,
            }}
          >
            <Avatar
              alt={name}
              src={profilePicture}
              imgProps={{ referrerPolicy: 'no-referrer' }}
              sx={{ width: 32, height: 32, fontSize: '0.85rem' }}
            >
              {name.charAt(0)}
            </Avatar>
            <Typography
              variant="body1"
              sx={{ ml: theme.spacing(1) }}
            >
              {name}
            </Typography>
          </Box>
        )}
        {reviewTitle && (
          <Typography
            variant="h6"
            sx={{ mt: theme.spacing(2) }}
          >
            {reviewTitle}
          </Typography>
        )}
        <ReviewText text={reviewText} />
      </ReviewContent>
      <ReviewFooter
        platform={platform}
        history={history}
        hide={hideFooter}
        reviewId={id}
        review={review}
        reviewComment={reviewComment}
        communityManagement={communityManagement}
        input={reviewText}
        username={name}
        commentingModule={commentingModule}
        companyComment={companyComment}
      />
    </ReviewWrapper>
  );
};

export default TripAdvisorReview;
